export enum RouteTo {
  ROOT = "/",

  // Auth
  LOGIN = "/login",
  //SIGNUP = "/signup",
  INVITE = "/invite",
  FORGOT_PASSWORD = "/forgot-password",
  RESET_PASSWORD = "/reset-password",

  ONBOARDING = "/onboarding",
  SHOP = "/shop",

  // App
  DASHBOARD = "/dashboard",
  CHAT = "/chat",
  KNOWLEDGE = "/knowledge",
  ABOUT = "/about",

  // Legal
  PRIVACY = "/datenschutz",
  LEGAL = "/impressum",

  // Terms & Conditions
  AGB = "/agb",

  USER_GUIDE = "/nutzerleitfaden",

  // Wissen
  WESENTLICHKEIT = "/wesentlichkeit",
  VIDEOS = "/videos",
  COMPASS = "/kompass",
  LEXIKON = "/lexikon",

  AI_SERVICES = "/ki-services",

  SUBSCRIPTION = "/abo",

  CONTACT = "/kontakt",

  // Admin routes
  ADMIN_LOGIN = "/admin/login",
  ADMIN_DASHBOARD = "/admin/dashboard",
  ADMIN_COMPANIES = "/admin/companies",
  ADMIN_USERS = "/admin/users",
  ADMIN_DOCUMENTS = "/admin/documents",
  ADMIN_UPDATES = "/admin/updates",
  ADMIN_CHATS = "/admin/chats",
  ADMIN_SERVICES = "/admin/services",
  ADMIN_SYNC = "/admin/sync",
}

export enum RouteToSettings {
  ROOT = "/settings",

  // General
  DEFAULT = "/settings/profile/general",

  // App Settings
  DASHBOARD = "/settings/app/dashboard",
  CHAT = "/settings/app/chat",

  // Profile Settings
  ACCOUNT_GENERAL = "/settings/account/general",
  PROFILE_GENERAL = "/settings/profile/general",
  PROFILE_PROJECTS = "/settings/profile/projects",
  PROFILE_NEWSLETTER = "/settings/profile/newsletter",

  // Company Settings
  COMPANY_PROFILE = "/settings/company/profile",
  COMPANY_PROFILE_READONLY = "/settings/company/profile-view",
  COMPANY_PROJECTS = "/settings/company/projects",
  COMPANY_USERS = "/settings/company/users",
  // COMPANY_PAYMENTS = "/settings/company/payments",
  COMPANY_SUBSCRIPTION = "/settings/company/subscription",
  LAW_SELECTION = "/settings/company/laws",

  // Shop
  SHOP_SAAS = "/settings/shop/esgbot-saas",
  SHOP_AI_SERVICE = "/settings/shop/ki-service",
  SHOP_CONSULTING = "/settings/shop/consulting",
  SHOP_EXTRA_PAGES = "/settings/shop/extra-pages",

  TEST = "/settings/app/test",
}

export enum ExternalLinks {
  ESGBOT = "https://esgbot.de",
  LINKEDIN = "https://www.linkedin.com/company/esgbot",
}
